import { render } from "./TaxResidence.vue?vue&type=template&id=ad9cc4d6&ts=true"
import script from "./TaxResidence.vue?vue&type=script&lang=ts"
export * from "./TaxResidence.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__